/**
 * Normalise API contributor objects into rows for ContributorsBarChartCard / repository tab.
 * @param {Array<Record<string, unknown>>} contributors
 * @returns {Array<Record<string, unknown>>}
 */
export function normalizeContributorRows(contributors) {
  if (!Array.isArray(contributors)) return [];
  return contributors.map((c, i) => ({
    ...c,
    totalCommits: c.totalCommits ?? (Array.isArray(c.commits) ? c.commits.length : c.commits) ?? 0,
    linesAdded: Number(c.linesAdded) || 0,
    linesDeleted: Number(c.linesDeleted) || 0,
    pullRequests: Number(c.pullRequests) || 0,
    lastCommitDate: c.lastCommitDate ?? null,
    displayName: c.name || c.contributorName || c.email || 'Unknown',
    displayEmail: c.email || c.contributorEmail || '',
    isActive: c.isActive,
    _rowKey: String(c.id ?? c.email ?? c.contributorEmail ?? `contributor-${i}`),
  }));
}
